export const mavigpsSVG = "./assets/logos/mavigps.svg";
export const historicalInfoSVG = "./assets/icons/historical-info.svg";
export const activeServicesSVG = "./assets/icons/activeServices.svg";
export const warehouseSVG = "./assets/icons/warehouse.svg";
export const usersSvg = "./assets/icons/account-group.svg";
export const stockSVG = "./assets/icons/cars.svg";
export const settingSVG = "./assets/icons/settings.svg";
export const dashboarSVG = "./assets/icons/mavigps-dashboard.svg";
export const logoutSVG = "./assets/icons/logout.svg";
export const flagSVG = "./assets/icons/flag-line.svg";
export const traceSVG = "./assets/icons/last_travel.svg";
export const simCardSVG = "./assets/icons/sim.svg";
export const deviceSvg = "./assets/icons/cassette.svg";
export const transmissionValidatorSVG = "./assets/icons/access-point.svg";
export const searchSVG = "./assets/icons/search.svg";
export const launchSVG = "./assets/icons/launch.svg";
export const gpsOnSVG = "./assets/icons/gpsOn.svg";
export const gpsOffSVG = "./assets/icons/gps_off.svg";
export const angleLeftSVG = "./assets/icons-bkp/angle-line-left.svg";
export const angleDownSVG = "./assets/icons-bkp/angle-down-line.svg";
export const angleUpSVG = "./assets/icons-bkp/angle-up-line.svg";
export const errorCircleSVG = "./assets/icons/times-circle-line.svg";
export const checkCircleSVG = "./assets/icons/check-circle-line.svg";
export const uploadSVG = "./assets/icons/upload-line.svg";
export const downloadSVG = "./assets/icons/arrow-collapse-down.svg"
export const userSVG = "./assets/icons/user-line.svg";
export const editSVG = "./assets/icons/edit.svg";
export const circleEditOutlineSVG = "./assets/icons/circle-edit-outline.svg";
export const infoSVG = "./assets/icons//information-variant.svg";
export const visitPlaceSVG = "./assets/icons/visit_place.svg";
export const carSVG = "./assets/icons/car.svg";
export const closeSvg = "./assets/icons/delete.svg";
export const officeBuildingSVG = "./assets/icons/office-building.svg";
export const excelSVG = "./assets/icons/file-excel-outline.svg";
export const formSVG = "./assets/icons/format-list-text.svg";
export const unsubscribeSVG = "./assets/icons/unsubscribe-icon.svg";

//Image Background
export const coworkerSVG = './assets/images/coworker.svg';
export const factoryBackgroundSVG = "./assets/images/factory.svg";
export const ticketsProcessBackgroundSVG = "./assets/images/tickets.svg";
export const contactBackgroundSVG = "./assets/images/contact.svg";
export const usersBackgroundSVG = "./assets/images/users.svg";
export const famaleSVG = "./assets/images/female.svg";
export const maleSVG = "./assets/images/male.svg";
export const peopleSVG = "./assets/images/people.svg";
export const comingHomeSVG = "./assets/images/coming_home.svg";
export const signalSearchingSVG = "./assets/images/signal_searching.svg";
export const warningSVG = "./assets/images/warning.svg";
export const uploadImageSVG = "./assets/images/image_upload.svg";
export const syncFileSvg = "./assets/images/sync_files_xb3r.svg";
export const dashboardSVG = "./assets/icons/dashboard.svg";

